import React from "react"
import Imgix from "react-imgix"
import Helmet from "react-helmet"
import Layout from "../components/layout"
import SEO from "../components/seo"
import SubheaderCovid from "../components/subheader-covid"

import app from "../images/about/app.svg"
import hardware from "../images/about/hardware.svg"
import monitoring from "../images/about/monitoring.svg"
import install from "../images/about/install.svg"
import support from "../images/about/support.svg"

import yale from "../images/about/yale-logo.svg"
import qolsys from "../images/about/qolsys-logo.svg"
import alarm from "../images/about/alarm.svg"
import alarmPower from "../images/about/alarm-power.svg"

const AboutPage = () => (
  <Layout className="about" headerSeparator>
    <Helmet>
      <html lang="en" />
      <title>About BrightSuite | Smart Home. Simplified.</title>
    </Helmet>
    <div className="about__wrapper">
      <div className="image">
        <Imgix
          src="https://brightsuite.imgix.net/hero_about.jpg"
          width={624}
          // height={624}
        />
      </div>
      <div className="desc">
        <div className="title">About BrightSuite</div>
        <p className="desc__p">
        BrightSuite does more than make homes smarter, it lets you truly enjoy your home technology instead of feeling like you’re fighting against it. We've paired the safety and reliability of our parent company, Dominion Energy, with the most innovative smart home and security products on the market, to bring you intelligent experiences that make life easier, safer, and more satisfying.
        </p>
        <p className="desc__p">
        As smart home technology continues to evolve, so will BrightSuite. We plan to connect more devices and resources to BrightSuite's intelligent platform, allowing our customers flexibility, customization, and the ability to live more sustainably.
        </p>
        <p className="desc__p">
        That feeling that you get when everything just works? It’s strangely powerful. It’s blissfully reassuring. It’s Brightly Satisfying.
        </p>
        <div className="notes">
          <div className="note">
            <div className="note__header">
              <img src={app} className="note__icon" alt="Mobile App" />
              Mobile App
            </div>
            <div className="note__desc">
              Whether you're home or away, you can control your entire home
              through a single, intuitive interface on your mobile device. See
              who's at the front door, dim the lights, adjust the temperature,
              watch live video, and secure your home, all with a few clicks from
              wherever you are.
            </div>
            <div className="note__featuring">
              <img src={alarmPower} alt="powered by Alarm.com" />
            </div>
          </div>
          <div className="note">
            <div className="note__header">
              <img src={hardware} className="note__icon" alt="Mobile App" />
              Hardware Partners
            </div>
            <div className="note__desc">
              We've carefully chosen best-in-class hardware and software to
              intelligently equip your home, backed by award-winning partners
              such as Alarm.com, Qolsys and Yale. These partners work together
              with BrightSuite to seamlessly deliver service as one team,
              focused on using technology to empower you in your day-to-day
              life.
            </div>
            <div className="note__featuring">
              <img src={alarm} alt="Alarm.com" />
              <img src={yale} alt="Yale" />
              <img src={qolsys} alt="Qolsys" />
            </div>
          </div>
          <div className="note">
            <div className="note__header">
              <img src={monitoring} className="note__icon" alt="Mobile App" />
              Central Monitoring
            </div>
            <div className="note__desc">
              Each BrightSuite home is backed by 24/7 professional monitoring,
              with on-demand access to a live agent at our award-winning
              response facility. In the event of an emergency, agents in our two
              fully redundant facilities in New York and California will work
              with your local emergency management agencies—including police,
              fire, and medical services—to ensure a rapid response.
            </div>
          </div>
          <div className="note">
            <div className="note__header">
              <img src={install} className="note__icon" alt="Mobile App" />
              Installer Network
            </div>
            <div className="note__desc">
              We understand that your family's safety and security can't wait,
              so when you call for service, one of our fully licensed
              professional installers will arrive within a one-hour window of
              your scheduled appointment time. For DIY types, we also offer easy
              self-setup options for many of our systems.
            </div>
          </div>
          <div className="note">
            <div className="note__header">
              <img src={support} className="note__icon" alt="Mobile App" />
              Customer Support
            </div>
            <div className="note__desc">
              Our highly trained customer support agents—who undergo extensive
              background clearances and fingerprint checks—are ready to assist
              you with any support need you may have. From help with system or
              app setup, to after-hours support for non-emergency incidents
              (emergencies route directly to our monitoring team), our support
              staff is committed to making sure you and your home are properly
              taken care of.
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
)

export default AboutPage
